import React, { useEffect, useState } from "react";
import { admin } from "../../lib/api";

export default function Analytics() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    (async () => setData(await admin.analytics()))();
  }, []);

  const digest = async () => {
    setBusy(true); setMsg(null);
    try {
      const res = await admin.digestRun();
      setMsg(`Digest generated with ${res.rows_included} rows. See Email Log.`);
    } catch { setMsg("Could not send digest."); }
    finally { setBusy(false); }
  };

  if (!data) return <p data-testid="analytics-loading">Loading…</p>;

  return (
    <div data-testid="analytics-page">
      <div className="cw-eyebrow">Analytics</div>
      <h1 className="cw-display-l" style={{ marginTop: 8 }}>Funnel at a glance.</h1>

      <div className="cw-metric-grid" style={{ marginTop: 32 }}>
        <div className="cw-metric" data-testid="metric-total-leads">
          <div className="cw-label">Total leads</div>
          <div className="val">{data.total_leads}</div>
        </div>
        <div className="cw-metric" data-testid="metric-completion">
          <div className="cw-label">Completion rate</div>
          <div className="val">{data.completion_rate}%</div>
        </div>
        <div className="cw-metric" data-testid="metric-reports-delivered">
          <div className="cw-label">Reports delivered</div>
          <div className="val">{data.reports_delivered}</div>
        </div>
        <div className="cw-metric" data-testid="metric-reports-queued">
          <div className="cw-label">Reports queued</div>
          <div className="val">{data.reports_queued}</div>
        </div>
      </div>

      <h2 className="cw-heading-m" style={{ marginTop: 32 }}>Funnel states</h2>
      <div className="cw-metric-grid" style={{ marginTop: 12 }}>
        {Object.entries(data.states).map(([k, v]) => (
          <div className="cw-metric" key={k} data-testid={`state-${k}`}>
            <div className="cw-label">{k}</div>
            <div className="val">{v}</div>
          </div>
        ))}
      </div>

      <h2 className="cw-heading-m" style={{ marginTop: 32 }}>Tiers</h2>
      <div className="cw-metric-grid" style={{ marginTop: 12 }}>
        {Object.entries(data.tiers).map(([k, v]) => (
          <div className="cw-metric" key={k} data-testid={`tier-${k}`}>
            <div className="cw-label">{k}</div>
            <div className="val">{v}</div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 40 }}>
        <button
          className="cw-btn light-primary"
          onClick={digest}
          disabled={busy}
          data-testid="run-digest-btn"
        >{busy ? "Sending…" : "Send digest now"}</button>
        {msg && <p className="cw-small" style={{ marginTop: 12 }} data-testid="digest-msg">{msg}</p>}
      </div>
    </div>
  );
}
